import * as yup from 'yup';

/** Синхронная проверка email для API (не зависит от тайминга react-hook-form). */
const STRICT_EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;

export function isLoginEmailValidForQuery(email: string | undefined): boolean {
    const trimmed = (email ?? '').trim();
    if (!trimmed) return false;
    // Более строгая проверка для защиты от промежуточных значений автоподстановки iOS.
    // Требуем наличие точки в доменной части и минимум 2 символа в TLD.
    if (!STRICT_EMAIL_REGEX.test(trimmed)) return false;

    // Оставляем yup как финальную проверку.
    return yup.string().email().isValidSync(trimmed);
}

export const createLoginSchema = (t: any) =>
    yup.object({
        email: yup
            .string()
            .required(t.login.validation.emailRequired)
            .matches(STRICT_EMAIL_REGEX, t.login.validation.emailInvalid)
            .email(t.login.validation.emailInvalid)
            .trim(),
        password: yup
            .string()
            .required(t.login.validation.passwordRequired)
            .min(1, t.login.validation.passwordRequired)
            .trim(),
        rememberMe: yup.boolean().default(false),
    });

export type LoginFormData = yup.InferType<ReturnType<typeof createLoginSchema>>;
